<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดเก็บข้อมูลจากเว็บไซต์ผู้ให้บริการ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-user"></i> จัดเก็บข้อมูลจากเว็บไซต์ผู้ให้บริการ
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <el-form
                    size="mini"
                    :label-position="label_position"
                    label-width="150px"
                    :model="form"
                    class="demo-ruleForm"
                  >
                    <div class="col-sm-6">
                      <div class="col-sm-12">
                        <el-form-item label="ประเภทของผู้ให้บริการ" required>
                          <el-radio-group v-model="form.provider_type" @change="pickType()">
                            <el-radio label="mobile">โทรศัพท์เคลื่อนที่</el-radio>
                            <el-radio label="broadband">อินเทอร์เน็ตความเร็วสูงประจำที่</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </div>
                      <div class="col-sm-12">
                        <el-form-item label="ผู้ให้บริการ" required>
                          <el-checkbox-group v-model="form.provider_name" @change="handleCheck">
                              <!-- <template v-for="provider in store_providers"> -->
                              <template v-for="provider in all_provider_list">
                                <el-checkbox
                                  v-if="provider.provider_type == form.provider_type"
                                  :label="provider.brand_name_th" 
                                  :value="provider.provider_name+','+provider.provider_type"
                                  :key="provider.id"
                                ></el-checkbox>
                              </template>
                          </el-checkbox-group>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <el-form-item label="ชนิดของการให้บริการ">
                        <el-select v-model="form.promotion_category" >
                          <el-option value="FTTx" label="FTTx"  v-if="form.provider_type == 'broadband'"></el-option>
                          <el-option value="ADSL" label="ADSL"  v-if="form.provider_type == 'broadband'"></el-option>
                          <el-option value="VDSL" label="VDSL"  v-if="form.provider_type == 'broadband'"></el-option>
                          <el-option value="WiFi" label="WiFi"  v-if="form.provider_type == 'broadband'"></el-option>
                          <el-option value="VAS"  label="VAS"  v-if="form.provider_type == 'broadband'"></el-option>
                          <el-option value="prepaid"  label="Prepaid"  v-if="form.provider_type == 'mobile'"></el-option>
                          <el-option value="postpaid" label="Postpaid"  v-if="form.provider_type == 'mobile'"></el-option>
                          <el-option value="" label="ทั้งหมด"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="col-sm-6">
                      <el-form-item label="ประเภทของการให้บริการ">
                        <el-select v-model="form.promotion_type">
                          <el-option value="main" label="Main" ></el-option>
                          <el-option value="on-top"   label="on-top" ></el-option>
                          <el-option value="" label="ทั้งหมด"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="col-sm-6">
                      <el-form-item label="วันที่จัดเก็บข้อมูล">
                          <el-date-picker
                            type="date"
                            v-model="form.start_date"
                            placeholder="เริ่มต้น"
                          ></el-date-picker>
                          -
                          <el-date-picker
                            type="date"
                            v-model="form.end_date"
                            placeholder="สิ้นสุด"
                          ></el-date-picker>
                      </el-form-item>
                    </div>
                    <div class="col-sm-6">
                      <el-form-item label="สถานะการตรวจสอบ" required>
                        <el-radio-group v-model="form.status">
                          <el-radio :label="1">พบในข้อมูลนำส่ง</el-radio>
                          <el-radio :label="0">ไม่พบในการนำส่งข้อมูล</el-radio>
                          <el-radio :label="''">ทั้งหมด</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </div>
                    <br>
                    <div class="col-xs-12 layout_filter_btn">
                      <el-button type="primary" @click="Confirm()">ค้นหา</el-button>
                    </div>
                  </el-form>
                </div>
              </div>
              <br>
              <!-- /.box-header -->
              <div class="table-responsive">
                <div class="box-body" >
                  <div v-if="this.download_form!= null" align="right">
                    <el-button @click="get_download_data" type="primary" style="margin-right:10px; margin-bottom: 20px">Export</el-button>
                  </div>
                  <data-tables-server
                    @query-change="fetchData"
                    :data="store_promotions"
                    :page-size="10"
                    :total="store_total"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    :table-props="tableProps"
                  >
                    <el-table-column prop="promotion_name" label="ชื่อรายการส่งเสริมการขาย" width="270" ></el-table-column>
                    <el-table-column prop="category" label="ชนิดของการให้บริการ" width="270" ></el-table-column>
                    <el-table-column prop="type" label="ประเภทของการให้บริการ" width="270" ></el-table-column>
                    <el-table-column prop="promotion_price" label="ราคา" width="100"></el-table-column>
                    <el-table-column prop="provider_name" label="ผู้ให้บริการ" width="200"></el-table-column>
                    <el-table-column prop="status" label="สถานะการตรวจสอบ" width="200"></el-table-column>
                    <el-table-column prop="website_url" label="เว็บไซต์" width="200"></el-table-column>
                    <el-table-column prop="created_at" label="วันที่จัดเก็บข้อมูล" width="200"></el-table-column>
                    <el-table-column label="จัดการ" align="center" :width="menu_width" fixed="right">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="ดูข้อมูล" placement="top">
                          <el-button
                            class="custom-btn"
                            size="mini"
                            type="success"
                            @click="handleView(scope.$index, scope.row)"
                          >
                            <i class="el-icon-view"></i>
                          </el-button>
                        </el-tooltip>
                        <!-- <el-tooltip class="item" effect="light" content="ลบ" placement="top">
                          <el-button
                            class="custom-btn"
                            size="mini"
                            type="danger"
                            v-if="permission.includes('delete')"
                            @click="handleDelete(scope.row)"
                          >
                            <i class="el-icon-delete-solid"></i>
                          </el-button>
                        </el-tooltip> -->
                      </template>
                    </el-table-column>
                  </data-tables-server>
                  <!-- dialog -->
                  <el-dialog title="รายละเอียดรายการส่งเสริมการขาย" :visible.sync="dialogFormVisible">
                      <h5>ชื่อรายการส่งเสริมการขาย <b>:</b> {{ this.dialog_data.promotion_name }}</h5>
                      <h5>ราคา (บาท) <b>:</b> {{ this.dialog_data.promotion_price }}</h5>
                      <h5>ชนิดของรายการส่งเสริมการขาย <b>:</b> {{ this.dialog_data.category }}</h5>
                      <h5>ประเภทบริการของรายการส่งเสริมการขาย <b>:</b> {{ this.dialog_data.type }}</h5>
                      <h5>ผู้ให้บริการ <b>:</b> {{ this.dialog_data.provider_name }}</h5>
                      <h5>ประเภทของผู้ให้บริการ <b>:</b> {{ this.dialog_data.provider_type }}</h5>
                      <div v-if="this.dialog_data.provider_type == 'broadband'">
                        <h5>ความเร็วดาวน์โหลด (Mbps) <b>:</b> {{ this.dialog_data.download_speed }} </h5>
                        <h5>เงื่อนไขความเร็วดาวน์โหลด <b>:</b> {{ this.dialog_data.download_condition }}</h5>
                        <h5>ความเร็วอัปโหลด (Mbps) <b>:</b> {{ this.dialog_data.upload_speed }}</h5>
                        <h5>เงื่อนไขความเร็วอัปโหลด <b>:</b> {{ this.dialog_data.upload_condition }}</h5>
                      </div>
                      <div v-if="this.dialog_data.provider_type == 'mobile'">
                        <h5>บริการเสียง (นาที) <b>:</b> {{ this.dialog_data.voice_service }}</h5>
                        <h5>เงื่อนไขบริการเสียง <b>:</b> {{ this.dialog_data.voice_condition }}</h5>
                        <h5>บริการส่งข้อความ SMS (ข้อความ) <b>:</b> {{ this.dialog_data.sms_service }}</h5>
                        <h5>เงื่อนไขบริการส่งข้อความ SMS <b>:</b> {{ this.dialog_data.sms_condition }}</h5>
                        <h5>บริการส่งข้อความ MMS (ข้อความ) <b>:</b> {{ this.dialog_data.mms_service }}</h5>
                        <h5>เงื่อนไขบริการส่งข้อความ MMS <b>:</b> {{ this.dialog_data.mms_condition }}</h5>
                        <h5>บริการอินเทอร์เน็ต (MB) <b>:</b> {{ this.dialog_data.internet_service }}</h5>
                        <h5>เงื่อนไขบริการอินเทอร์เน็ต <b>:</b> {{ this.dialog_data.internet_condition }}</h5>
                      </div>
                      <h5>บริการอื่น ๆ <b>:</b> {{ this.dialog_data.other_service }}</h5>
                      <h5>ข้อกำหนดและเงื่อนไขแพ็กเกจ <b>:</b> {{ this.dialog_data.promotion_condition }}</h5>
                      <h5>ลิงก์เว็บไซต์รายการส่งเสริมการขาย <b>:</b> <a :href="this.dialog_data.website_url"> {{this.dialog_data.website_url}} </a> </h5>
                  </el-dialog>
                </div>
                <!-- /.box-body -->
              </div>
              <!--table-responsive-->
            </div>
            <!-- /.box -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import {mapActions,mapState} from 'vuex'
export default {
  created() {
    this.$store.dispatch('Manage_operator/getAvailableOperator')
  },
  data() {
    return {
      dialog_data : {},
      dialogFormVisible: false,
      dialogVisible: false,
      tableProps: {
        border: true,
        // stripe: true,
        defaultSort: {
          prop: "flow_no",
          order: "descending"
        }
      },
      label_position: "top",
      form: { 
        promotion_name: null,
        provider_type: 'mobile', 
        provider_name: [] ,
        promotion_category: "",
        promotion_type: "",
        status: '',
        start_date: null,
        end_date: null,
        provider_id: [] 
      },
      provider_list : [],
      backupform : null,
      permission : [],
      menu_width : 120
    };
  },
  mounted(){
    this.permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission)).Manage_data
    this.menu_width = this.permission.includes('delete') ? 120 : 80
    this.$store.dispatch('Promotion_website/get_provider_list')
  },
  computed : {
    ...mapState({
      store_providers : store => store.Promotion_website.providers,
      store_promotions : store => store.Promotion_website.data_table,
      store_total : store => store.Promotion_website.total,
      loading : store => store.Promotion_website.loading,
      download_form : store => store.Promotion_website.download_form,
      all_provider_list : store=> store.Manage_operator.select_lists
    })
  },
  watch : {
    store_providers : {
      handler : function(reload, empty){
        this.provider_list = reload
      }
    }
  },
  methods: {
    ...mapActions({
      search : 'Promotion_website/find_promotion',
      get_provider : 'Promotion_website/get_provider_list',
      delete : 'Promotion_website/remove_promotion',
      fetch_data : 'Promotion_website/fetch_data',
      download : 'Promotion_website/download_promotion'
    }),
    get_download_data() {
      this.download(this.download_form)
    },
    handleClose(done) {
      done();
    },
    fetchData(queryInfo) {
      let forminfo = Object.assign(queryInfo,this.form)
      this.backupform = forminfo
      this.fetch_data(forminfo)
    },
    change_view() {
      this.$router.push({ name: "Add_admin" });
    },
    handleView(index, row) {
      this.dialog_data = row;
      this.dialogFormVisible = !this.dialogFormVisible;
    },
    handleEdit(index, row) {
      this.$router.push({ name: "Edit_admin" });
    },
    handleDelete(row) {
      this.$confirm("ลบข้อมูลรายการส่งเสริมการขาย", "แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      }).then(() => {
        this.delete(row)
      }).catch(() => {});
    },
    pickType(){
      this.form.provider_name = []
      this.form.provider_id = []
      this.form.promotion_category = null
      this.form.promotion_type = null
    },
    Confirm() {
      if(!this.form.provider_name.length){
        return this.MessageBox("แจ้งเตือน","กรุณาเลือกผู้ให้บริการ","warning",false)
      }else{
        this.$store.commit('Promotion_website/SET_LOADING',true)
        this.search(this.form)
      }
    },
    handleCheck() {
      let temp = this.all_provider_list.filter(provider => this.form.provider_name.includes(provider.brand_name_th) && (provider.provider_type == this.form.provider_type))
      this.form.provider_id = temp.map(provider => provider.id)
    }
  }
};
</script>

<style>
.layout_filter_btn {
  /* text-align: center; */
}
.redText {
  color: red;
}
.greenText{
  color : green;
}
</style>
